import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgWan = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-wan';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.34 3.28a8.7 8.7 0 0 0-5.521 2.54c-1.344 1.343-2.192 3.027-2.485 4.94-.096.63-.096 1.85 0 2.48.398 2.594 1.87 4.839 4.07 6.205 1.518.943 3.456 1.42 5.206 1.282 2.156-.17 4.069-1.044 5.571-2.546s2.376-3.415 2.546-5.571c.214-2.714-.976-5.533-3.073-7.281-1.795-1.495-4.009-2.214-6.314-2.049m1.049 1.582c.863.43 1.688 2.163 2.049 4.308.099.585.201 1.52.202 1.84v.23H14v1.52h.64v.23c-.002.598-.198 1.975-.4 2.802-.493 2.019-1.421 3.448-2.24 3.448-.785 0-1.687-1.33-2.179-3.212-.243-.929-.461-2.37-.461-3.048v-.22H10v-1.52h-.64v-.22c0-.354.118-1.397.224-1.98.322-1.765.892-3.139 1.601-3.853.418-.421.803-.525 1.204-.325M9.02 5.77c-.614 1.283-1.041 3.132-1.163 5.04l-.028.43H7v1.52h.829l.028.43c.122 1.912.544 3.74 1.164 5.04.118.247.197.45.176.45-.053 0-.646-.298-.937-.472a7.8 7.8 0 0 1-1.983-1.772c-.759-.997-1.209-2.015-1.42-3.216-.087-.491-.11-.455.293-.468l.35-.012v-1.48l-.35-.012c-.403-.013-.38.023-.293-.468A7.29 7.29 0 0 1 8.1 5.898c.297-.191 1.023-.576 1.088-.577.026-.001-.048.197-.168.449m6.198-.26c2.143 1.074 3.661 3.186 3.965 5.518l.027.209-.355.011-.355.012v1.48l.355.012.355.011-.027.209c-.276 2.114-1.604 4.135-3.443 5.236-.288.172-.883.472-.937.472-.021 0 .058-.203.176-.45.62-1.3 1.042-3.128 1.164-5.04l.028-.43H17v-1.52h-.829l-.028-.43c-.122-1.913-.544-3.74-1.165-5.042-.245-.515-.254-.506.24-.258m-3.96 5.781c-.011.029-.015.366-.009.75l.011.699.75.011.75.011V11.24h-.741c-.567 0-.746.012-.761.051"
    })
  }));
});
export default SvgWan;